export default "__VITE_ASSET__DDODIeug__"